import * as React from 'react';
import { FilterList, FilterListItem } from 'react-admin';

export const HasCustomerTypeFilter = () => (
    <FilterList
        label="업종"
    >
        <FilterListItem
            label="IT"
            value={{ has_it: true }}
        />
        <FilterListItem
            label="도소매"
            value={{ has_retail: true }}
        />
        <FilterListItem
            label="제조"
            value={{ has_manufacture: true }}
        />
    </FilterList>
);

export const HasCountFilter = () => (
    <FilterList
        label="식수인원"
    >
        <FilterListItem
            label="0~50"
            value={{ has_small: true }}
        />
        <FilterListItem
            label="51~100"
            value={{ has_medium: true }}
        />
        <FilterListItem
            label="101 ~"
            value={{ has_large: true }}
        />
    </FilterList>
);

export const HasAgeFilter = () => (
    <FilterList
        label="주요연령"
    >
        <FilterListItem
            label="10대"
            value={{ has_10: true }}
        />
        <FilterListItem
            label="20대"
            value={{ has_20: true }}
        />
        <FilterListItem
            label="30대"
            value={{ has_30: true }}
        />
        <FilterListItem
            label="40대"
            value={{ has_40: true }}
        />
        <FilterListItem
            label="50대"
            value={{ has_50: true }}
        />
    </FilterList>
);

export const HasGenderFilter = () => (
    <FilterList
        label="성비"
    >
        <FilterListItem
            label="남성우세"
            value={{ has_mail: true }}
        />
        <FilterListItem
            label="여성우세"
            value={{ has_femail: true }}
        />
        <FilterListItem
            label="동비"
            value={{ has_even: true }}
        />
    </FilterList>
);

export const HasMealFilter = () => (
    <FilterList
        label="식사시간"
    >
        <FilterListItem
            label="아침"
            value={{ has_breakfast: true }}
        />
        <FilterListItem
            label="점심"
            value={{ has_lunch: true }}
        />
        <FilterListItem
            label="저녁"
            value={{ has_dinner: true }}
        />
    </FilterList>
);
